import $ from 'jquery'

export default () => {
  $(() => {
    /**
     * toggle sub menu on mobile
     */
    $('header.site-header nav.main-navigation .menu-toggle').click(e => {
      e.preventDefault()
      $(e.target).toggleClass('icon-chevron-thin-down icon-chevron-thin-up').parent().children('.sub-menu').slideToggle()
    })

    /**
     * toggle hamburger menu icon on mobile
     */
    $('header.site-header .hamburger').click(e => {
      $(e.target).toggleClass('icon-menu icon-cancel')
      $('.overlay').toggleClass('show')
    })
  })
}
